module.exports = __webpack_public_path__ + "static/media/talk-2-final.0d0bb2e2.png";